import { NOTIFICATION_ALERT, NOTIFICATION_SUCCESS, NOTIFICATION_FAILURE } from './const';

export const defaultState = {
  message: null
};

/**
 * Reducer for notifications
 * @param {object} state - existing state
 * @param {object} action - action that's occuring
 * @returns {object} new state
 */
const reducer = function notificationsReducer(state = defaultState, action = {}) {
  switch (action.type) {
    case NOTIFICATION_ALERT:
      return {
        classification: 'alert',
        date: action.date,
        message: action.message
      };
    case NOTIFICATION_SUCCESS:
      return {
        classification: 'success',
        date: action.date,
        message: action.message
      };
    case NOTIFICATION_FAILURE:
      return {
        classification: 'failure',
        date: action.date,
        message: action.message
      };
    default:
      return state;
  }
};

export default reducer;
